import type {
  SyncParticipantsUsecase,
  SyncParticipantsRequest,
} from '@usecases/sync-participants.usecase';
import { InvalidSyncParticipantsRequest } from '@usecases/sync-participants.usecase';
import type { BaseController } from '@infra/controllers/base.controller';
import { Logger } from '@main/utils/logger';

export type SyncParticipantsOutput = InvalidSyncParticipantsRequest | void;

export class SyncParticipantsController
  implements BaseController<SyncParticipantsRequest, SyncParticipantsOutput>
{
  private logger: Logger;

  constructor(private usecase: SyncParticipantsUsecase) {
    this.logger = new Logger();
  }

  async handle(
    input: SyncParticipantsRequest,
  ): Promise<SyncParticipantsOutput> {
    this.logger.info('SyncParticipantsController: Received input', {
      action: 'SyncParticipants',
      callId: input.callId,
      activeParticipant: input.activeParticipant,
      me: input.me,
    });

    try {
      await this.usecase.run(input);
    } catch (error) {
      this.logger.error(
        'SyncParticipantsController: Error syncing participants',
        {
          action: 'SyncParticipants',
          error,
          input,
        },
      );
      if (error instanceof InvalidSyncParticipantsRequest) {
        return error;
      }
      throw error;
    }
  }
}
